<template>
    <div
        v-if="active"
        class="tw-fixed tw-max-w-xl tw-p-4 tw-bg-primary tw-left-8 tw-z-50 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out tw-bottom-8 tw-shadow-lg"
        :class="show ? 'tw-opacity-100' : 'tw-opacity-0'"
    >
        <div class="tw-text-white tw-text-sm tw-mb-4 tw-leading-normal">
            Nasz serwis wykorzystuje pliki cookies. Pliki cookies pozwalają na pełne korzystanie z możliwości strony oraz umożliwiają zbieranie danych statystycznych,które pomagają
            nam w optymalizacji serwisu oraz dostosowaniu treści do Twoich potrzeb. Korzystając z serwisu wyrażasz zgodę na wykorzystywanie plików cookies.
        </div>
        <div class="tw-flex tw-items-center tw-space-x-2">
            <a
                :href="cookiesLink"
                target="_blank"
                class="tw-flex tw-items-center tw-text-white tw-bg-transparent tw-text-center tw-text-sm tw-px-4 tw-h-10 tw-border tw-border-solid tw-border-white tw-rounded-md tw-leading-none tw-transition-all tw-duration-300 tw-ease-out hover:tw-text-white hover:tw-no-underline hover:tw-bg-white/10"
                >Dowiedz się więcej</a
            >
            <button
                class="tw-flex tw-items-center tw-text-white tw-bg-success tw-text-center tw-text-sm tw-px-4 tw-h-10 tw-border tw-border-solid tw-border-transparent tw-rounded-md tw-leading-none tw-transition-all tw-duration-300 tw-ease-out hover:tw-text-white hover:tw-no-underline hover:tw-bg-success-hover"
                @click="accept"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span>Rozumiem</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cookies',
        props: {
            cookiesLink: {
                type: String,
                default: '#',
            },
        },
        data() {
            return {
                active: false,
                show: false,
            }
        },
        methods: {
            accept() {
                this.show = false
                this.$cookies.set('cookieinfo', '1', '1y', '/')
                setTimeout(() => {
                    this.active = false
                }, 350)
            },
        },
        created() {
            let cookie = this.$cookies.get('cookieinfo')
            if (cookie === null || cookie === '0') {
                this.show = true
                this.active = true
            }
        },
    }
</script>

<style></style>
